import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeCard } from '../../actions/cardAction';
import { setStartedWithOfferCode, SetOfferCode } from '../../actions/offerCodeAction';
import { setIsMember } from '../../actions/applicationAction';
import { Button, Modal, ModalBody  } from 'reactstrap';
import ChooseCard from '../../components/ChooseCard/ChooseCard';
import { GetCards, GetWelcomeOfferCards } from '../../utils/ApplicationApi';
import { IsEndOfCampaign, IsEndOfLRCardsCampaign, IsEndOfNVWOCardsCampaign } from '../../utils/Validation';

import TagManager from 'react-gtm-module'

import './Home.scss';

const tagManagerArgs = {
  dataLayer: {
      pageCategory: 'Fees & important info',
      event: 'Credit Card Step 1'
  }
}

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      cardList: [],
      isLoaded: false
    };

    

    this.toggle = this.toggle.bind(this);
    this.changeCard = this.changeCard.bind(this);
    this.changeCardWithOfferCode = this.changeCardWithOfferCode.bind(this);
    this.setIsMember = this.setIsMember.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    this.mounted = true;

    TagManager.dataLayer(tagManagerArgs)

    const cpc = this.props.match.params.cpc;
    const tpc = this.props.match.params.tpc;
    const offerCode = this.props.match.params.offerCode;   
     
    if(offerCode) {
      let offerCodeStart = offerCode.substring(0, 2);
      let validOfferCode = /^[a-z0-9]+$/i.test(offerCode) && offerCode.length === 6 ? true : false;
      if((validOfferCode && offerCodeStart === "WE" && tpc === "VI" && cpc === "VPR")
        || (validOfferCode && offerCodeStart === "WE" && tpc === "VI" && cpc === "VIR")
        || (validOfferCode && tpc === "VS" && cpc === "RRR")
        || (validOfferCode && tpc === "VG" && cpc === "RRR")
        || (validOfferCode && tpc === "VS" && cpc === "LRR")
        || (validOfferCode && tpc === "VS" && cpc === "LRN")
        || (validOfferCode && tpc === "VG" && cpc === "LRR")
        || (validOfferCode && tpc === "VG" && cpc === "LRN")) {
        this.props.setStartedWithOfferCode(true);
        this.props.SetOfferCode(offerCode);
        if(this.state.cardList.length === 0) {
          GetWelcomeOfferCards().then(cardList => {
            let card;
            card = cardList.find(card => card.tpc === tpc && card.cpc === cpc);
            if(cardList.length > 0 && (Object.keys(this.props.card).length === 0 || card !== undefined)) {
  
              if(card === undefined) {
                this.props.changeCard(cardList[0]);
              }
              else {
                this.props.changeCard(card);
              }
            }
            this.setState({cardList: cardList, isLoaded: true});
          })
        } else {
          if(cpc && tpc) {
            let card = this.state.cardList.find(card => card.tpc === tpc && card.cpc === cpc);
            this.props.changeCard(card);
          }          
        }        
      } 
      else {
        this.props.setStartedWithOfferCode(false);
        if(this.state.cardList.length === 0) {      
          GetCards().then(cardList => {  
            if(this.mounted) {
              // Prepopulate the first card or retrieve card from URL
              let card;
    
              if(cpc && tpc) {
                card = cardList.find(card => card.tpc === tpc && card.cpc === cpc);
              }          
    
              if(cardList.length > 0 && (Object.keys(this.props.card).length === 0 || card !== undefined)) {
    
                if(card === undefined) {
                  this.props.changeCard(cardList[0]);
                }
                else {
                  this.props.changeCard(card);
                }
              }
              this.setState({cardList: cardList, isLoaded: true});
            }
          });
        } else {
           if(cpc && tpc) {
            let card = this.state.cardList.find(card => card.tpc === tpc && card.cpc === cpc);
            this.props.changeCard(card);
          }
        }        
      }
    } else {
      this.props.setStartedWithOfferCode(false);
      if(this.state.cardList.length === 0) {      
        GetCards().then(cardList => {  
          if(this.mounted) {
            // Prepopulate the first card or retrieve card from URL
            let card;
  
            if(cpc && tpc) {
              card = cardList.find(card => card.tpc === tpc && card.cpc === cpc);
            }          
  
            if(cardList.length > 0 && (Object.keys(this.props.card).length === 0 || card !== undefined)) {
  
              if(card === undefined) {
                this.props.changeCard(cardList[0]);
              }
              else {
                this.props.changeCard(card);
              }
            }
            this.setState({cardList: cardList, isLoaded: true});
          }
        });
      } else {
         if(cpc && tpc) {
          let card = this.state.cardList.find(card => card.tpc === tpc && card.cpc === cpc);
          this.props.changeCard(card);
        }
      }
    }    
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  toggle() {
    this.setState({
      modalOpen: !this.state.modalOpen
    });
  }
  closeModal() {
    this.setState({
      modalOpen: false
    });
  }
  changeCard(card) {
    this.props.changeCard(card);
    this.toggle();
  }

  // Product Backlog Item 435048: Update ASC Code/URL "Apply Now" Link End Dates
  // Product Backlog Item 444905: Update Online Visa Application, ARC, and ABC with New Vancity Visa Welcome Offer Campaign ASCs - Campaign end date:  June 26, 2024

  changeCardWithOfferCode(card) {
    this.props.changeCard(card);
    let newOfferCode = this.props.match.params.offerCode
 
    if (card.tpc === "VI") {
      if(card.cpc === "VIR" && !IsEndOfLRCardsCampaign())
        newOfferCode = "NFA20N";
      else if(card.cpc === "VPR" && !IsEndOfLRCardsCampaign())
        newOfferCode = "PRA20V";
      else if(card.cpc === "VIR" && !IsEndOfNVWOCardsCampaign())
        newOfferCode = "WELINF";
      else if (card.cpc === "VPR" && !IsEndOfNVWOCardsCampaign())
        newOfferCode = "WELIPN";
    }
 
    if(card.tpc === "VS") {
      if(card.cpc === "RRR" && !IsEndOfCampaign())
        newOfferCode = "WELCL1";
      else if(card.cpc === "LRN" && !IsEndOfLRCardsCampaign())
        newOfferCode = "WELCLN";
      else if(card.cpc === "LRR" && !IsEndOfLRCardsCampaign())
        newOfferCode = "WELCLR";
      else if(card.cpc === "LRN" && !IsEndOfNVWOCardsCampaign())
        newOfferCode = "WELCGL"
      else if (card.cpc === "LRR" && !IsEndOfNVWOCardsCampaign())
        newOfferCode = "WELCGL"
    }
 
    if(card.tpc === "VG") {
      if(card.cpc === "RRR" && !IsEndOfLRCardsCampaign())
        newOfferCode = "WELGD1"
      else if(card.cpc === "LRN" && !IsEndOfLRCardsCampaign())
        newOfferCode = "WELGLN"
      else if(card.cpc === "LRR" && !IsEndOfLRCardsCampaign())
        newOfferCode = "WELGLR"
      else if(card.cpc === "LRN" && !IsEndOfNVWOCardsCampaign())
        newOfferCode = "WELCGL"
      else if (card.cpc === "LRR" && !IsEndOfNVWOCardsCampaign())
        newOfferCode = "WELCGL"
      else if (card.cpc === "RRR" && !IsEndOfNVWOCardsCampaign())
        newOfferCode = "WELCGL"
    }
 
    this.props.history.replace('/Card/' + card.tpc + '/' + card.cpc + '/' + newOfferCode);
    this.props.SetOfferCode(newOfferCode);
    this.toggle();
  }
  setIsMember(event) {
    // Product Backlog Item 444905: Update Online Visa Application, ARC, and ABC with New Vancity Visa Welcome Offer Campaign ASCs - Campaign end date:  June 26, 2024
    // The below checks will dynamically change Visa Infinite Privilege Cards' offer codes for members & non-members:

    this.props.setIsMember(event.target.name);
    if (event.target.name === "true" && event.target.baseURI.slice(-6) === "WELIPN") {
      this.props.history.replace('/Card/' + 'VI' + '/' + 'VPR' + '/' + 'WELIPM');
      this.props.SetOfferCode('WELIPM');
      this.toggle();
    }
    if (event.target.name === "false" && event.target.baseURI.slice(-6) === "WELIPM") {
      this.props.history.replace('/Card/' + 'VI' + '/' + 'VPR' + '/' + 'WELIPN');
      this.props.SetOfferCode('WELIPN');
      this.toggle();
    }
    this.props.history.replace('/GetStarted');
  }
  render() {
    const modalCloseButton = <div className="close-modal" onClick={this.closeModal}></div>    
    
    let chooseCards;
    let displayCard = <div>
                        <div className="card-image"></div>
                        <h1>You’re applying for an...</h1>
                        <p className="heading"></p>
                        <a className="change-card disabled">Change card</a>
                      </div>;

    if(this.state.isLoaded) {
      displayCard = (
        <div>
          <div className={"card-image "+this.props.card.type}><div className="check-mark"></div></div>
          <h1>You’re applying for an {this.props.card.name}</h1>
          <h2>{this.props.card.benefits}</h2>
          {/* PBI 492661: VOA: Hide the 'Change Card' button for applications originating from the Email Campaign */}
          {((this.props.card.tpc === 'VG' && this.props.card.cpc === 'RRR') && (this.props.offerCode.offerCode === 'WELGD1' || this.props.offerCode.offerCode === 'WELGD2')) ? <a className="change-card disabled"></a> : <a className="change-card" onClick={this.toggle}>Change card</a>}
        </div>);
      if(this.props.offerCode.startedWithOfferCode) {
        chooseCards = this.state.cardList.map((card, i) => {
          return (<div className="choose-card-container" key={i}>
            <ChooseCard card={card} onClickApply={this.changeCardWithOfferCode} selected={(this.props.card.cpc === card.cpc && this.props.card.tpc === card.tpc)} />
          </div>);
        });
      } else {
        chooseCards = this.state.cardList.map((card, i) => {
          return (<div className="choose-card-container" key={i}>
            <ChooseCard card={card} onClickApply={this.changeCard} selected={(this.props.card.cpc === card.cpc && this.props.card.tpc === card.tpc)} />
          </div>);
        });
      }
    }
    return (
      <div className="home">
        {displayCard}
        <hr />
        <h3>Are you currently a Vancity member?</h3>
        <div className="button-container">
          <Button outline color="primary" name="true" onClick={this.setIsMember}>Yes</Button>
          <Button outline color="primary" name="false" onClick={this.setIsMember}>No</Button>
        </div>
        <Modal isOpen={this.state.modalOpen} toggle={this.toggle} className="choose-card-modal" modalClassName="home-modal" external={modalCloseButton} backdrop="static">
          <ModalBody>
            <h1>Choose a Vancity credit card</h1>
            <div className="choose-cards">
              {chooseCards}
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state,   
})

const mapDispatchToProps = dispatch => ({
  changeCard: card => dispatch(changeCard(card)),
  setIsMember : isMember => dispatch(setIsMember(isMember)),
  setStartedWithOfferCode: hasOfferCode => dispatch(setStartedWithOfferCode(hasOfferCode)),
  SetOfferCode: offerCode => dispatch(SetOfferCode(offerCode))

})

export default connect(mapStateToProps, mapDispatchToProps)(Home);


// WEBPACK FOOTER //
// ./src/containers/Home/Home.js